import { inject, injectable } from "@launchtray/tsyringe-async";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { Viewable } from "by/gamefactory/scene/viewable/Viewable";
import { PromiseCompletionSource } from "by/gamefactory/shared/async/PromiseCompletionSource";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { UnboardingType } from "../components/unboarding/UnboardingType";
import { UnboardingResourcePackage } from "../resources/UnboardingResourcePackage";
import { UnboardingPopupView } from "../views/unboarding/UnboardingPopupView";
import { IPlayerModel } from "../../../common/models/IPlayerModel";
import { DynamicResourcesPackage } from "resources/DynamicResourcesPackage";
import { IFirstTimeExperienceModel } from "../../../common/models/IFirstTimeExperienceModel";
import { VariableSaver } from "by/gamefactory/tools/variableSaver/VariableSaver";


export type UnboardingSceneOptions = {
    type: UnboardingType;
    buildingsResources: DynamicResourcesPackage;
}

@injectable()
export class UnboardingPopupScene extends Viewable<void> {
    public constructor(
        unboardingResources: UnboardingResourcePackage,
        commonResources: CommonResourcesPackage,
        @inject("ICanvasScaler") canvasScaler: ICanvasScaler,
        @inject("IPlayerModel") playerModel: IPlayerModel,
        @inject("IFirstTimeExperienceModel") firstTimeExperienceModel: IFirstTimeExperienceModel,
        @inject("UnboardingSceneOptions") options: UnboardingSceneOptions,
        variableSaver: VariableSaver
    ) {
        super();
        variableSaver.saveBoolean(`unboarding`, true);
        const pcs = new PromiseCompletionSource<void>();
        this.view = new UnboardingPopupView(
            pcs,
            canvasScaler,
            commonResources,
            unboardingResources,
            options.buildingsResources,
            playerModel,
            firstTimeExperienceModel,
            options.type
        );
        pcs.result.then(() => {
            this.operationControls.complete();
        }, (reason: unknown) => {
            this.operationControls.error(reason);
        });
    }
}
